export type Feature = {
  id: string;
  label: string;
};

export const FEATURES: Feature[] = [
  { id: "stock", label: "Stock" },
  { id: "sales", label: "Ventes" },
  { id: "returns", label: "Retours" },
  { id: "counting", label: "Comptage" },
  { id: "settings", label: "Paramètres" },
  { id: "budget", label: "Budget" },
  { id: "history", label: "Historique" },
  { id: "poultry", label: "Ferme Avicole" },
];